module.exports = __webpack_public_path__ + "static/img/shiChi.5f37bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/shiChi.png
// module id = IEEm
// module chunks = 1